<template>
  <div>
    <div class="mb-2 py-2 px-2 card-plain">
      <div class="row" style="height: 100%">
        <div class="col-6 col-md-6 float-left" style="cursor: pointer" @click="teacherDetail(dataTeacher.id)">
          <b-img class="rounded-circle" v-if="dataTeacher && dataTeacher.profile_image" :src="dataTeacher.profile_image"
            height="80px" width="80px"></b-img>
          <b-img class="rounded-circle" v-else :src="noImage" height="80px" width="80px"></b-img>
          <b-card-text>
            {{
              dataTeacher
                ? dataTeacher.first_name + " " + dataTeacher.last_name
                : ""
            }}
          </b-card-text>
        </div>
        <div class="col-6 col-md-6 text-left">
          <div>
            <span class="orange-text mr-2"> <i class="bi bi-star"></i></span>
            {{ lessonsAmount }}
            บทเรียน
          </div>
          <div>
            <span class="orange-text mr-2">
              <i class="bi bi-chat-text"></i></span>
            {{ quizAmount }} แบบทดสอบ
          </div>
          <div>
            <img class="mr-1" :src="playCircle" alt="" />
            {{ totalTime }} นาที
          </div>
          <div v-if="courseStatus">
            <button v-if="!courseStatus.isBan" class="btn btn-block btn-secondary mt-3">
              {{
                courseTimeCalculateDisabled(course.enroll)
                  ? cardText(course.enroll)
                  : courseStatus.user_enroll_status.name
              }}
            </button>
            <button v-else disabled class="btn btn-block btn-secondary mt-3">
              ระงับการใช้งาน
            </button>
          </div>
          <div v-else>
            <div class="mt-3"></div>

            <button v-if="courseCheckAccess(course)" class="btn btn-block main-orange-btn-outline mt-3"
              :disabled="courseTimeCalculateDisabled(course.enroll)" @click="register()">
              {{ cardText(course.enroll) }}
            </button>


            <button v-else @click="register()" :disabled="courseTimeCalculateDisabled(course.enroll) || !courseCheckApprove_rights()
              " class="btn btn-block main-orange-btn-outline mt-3">
              {{ cardText(course.enroll) }}
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import noImage from "../assets/image/mock/no-image.png";
import img from "./../../public/temp.jpg";
import playCircle from "../assets/image/icon/PlayCircle.png";
import { mapState } from "vuex";
import moment from "moment";



export default {
  name: "TeacherComponent",
  computed: {
    ...mapState({
      userData: (state) => state.Auth.userData,
      access_token: (state) => state.Auth.access_token,

    }),
  },

  data() {
    return {
      playCircle: playCircle,
      lessonsAmount: 0,
      quizAmount: 0,
      totalTime: 0,
      noImage: noImage,
      img: img,
      approve_rights: [],
      approve_rightsID: null,
    };
  },
  created() {
    this.countLesson();
  },
  props: {
    lessons: null,
    dataTeacher: null,
    courseStatus: null,
    course: { type: Object, default: null },
  },
  methods: {
    async teacherDetail(id) {
      let path = `/teacher-detail`;
      await this.$router.push({
        path: path,
        query: { id: id },
      });
    },
    cardText(enrolls) { let text = "ซื้อคอร์ส"; if (!enrolls) { text = "คอร์สเรียนสิ้นสุด"; } else { const enroll = enrolls[0]; let currentDate = moment(); let registerStart = enroll ? moment(enroll.register_start) : false; let registerEnd = enroll ? new moment(enroll.register_end) : false; let courseStart = enroll ? new moment(enroll.course_start) : false; let courseEnd = enroll ? new moment(enroll.course_end) : false; if (!currentDate.isBetween(registerStart, registerEnd) && enroll.user_enroll.length === 0) { text = "ปิดรับสมัคร"; } else if (!currentDate.isBetween(courseStart, courseEnd) && enroll.user_enroll.length > 0) { text = "คอร์สเรียนสิ้นสุด"; } else { text = "สมัครเรียน"; } } return text; },
    courseTimeCalculateDisabled(enrolls) {

      if (!enrolls) {
        return true;
      } else {
        const enrollsActive = enrolls.filter((enroll) => enroll.status);
        if (enrollsActive.length <= 0) {
          return true;
        } else {
          const now = moment();
          let disabled = true;

          const enroll = enrolls[0];
          const start_at = moment(enroll.register_start);
          const end_at = moment(enroll.register_end);

          const course_start_at = moment(enroll.course_start);
          const course_end_at = moment(enroll.course_end);


          if (start_at && end_at && course_start_at && course_end_at) {
            if (now <= course_end_at) {
              disabled = false;
            }
          }
          return disabled;
        }
      }
    },
    courseCheckApprove_rights() {


      if (this.course.approve_right != null) {
        return true;
      }
      else {
        return false;
      }

    },

    courseCheckAccess(course) {

      if (course.access_rights == "public") {
        return true
      }
      else {
        return false
      }
    },
    inTimeDuration(startTimeString, endTimeString) {
      const startTime = moment(startTimeString);
      const endTime = moment(endTimeString);
      const now = moment();

      return now >= startTime && now <= endTime;
    },
    checkCourseStatus() {
      const model = {
        user_id: this.userData.id,
        subject_id: this.course.id,
        accessToken: this.access_token,
      };
      this.$store
        .dispatch("Courses/checkCourseStatus", model)
        .then((response) => {
          this.courseStatus = response;
        });
    },

    countLesson() {
      const onlyLesson = this.lessons.filter((x) => x.type === "lesson");
      const onlyQuiz = this.lessons.filter((x) => x.type === "quiz");
      this.lessonsAmount = onlyLesson.length;
      this.quizAmount = onlyQuiz.length;
      this.totalTime = 0;
      onlyLesson.forEach((x) => {
        this.totalTime += x.lesson_minute;
      });
    },
    register() {
      if (!this.access_token) {
        this.$router.push("/login");
        return;
      }

      const enrollsActive = this.course.enroll.filter(
        (enroll) => enroll.status
      );

      //

      const now = moment();
      const enroll = enrollsActive.find((enroll) => {
        const start_at = moment(enroll.register_start);
        const end_at = moment(enroll.register_end);
        return now.isBetween(start_at, end_at);
      });

      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const model = {
            user_id: this.userData.id,
            subject_id: this.course.id,
            enroll_id: enroll.id,
          };
          this.$store
            .dispatch("Courses/registerCourse", {
              data: model,
              accessToken: this.access_token,
            })
            .then(() => {
              this.$emit("checkCourseStatus");
              Swal.clickConfirm();
            })
            .catch((err) => {
              if (err.response) {
                if (err.response.status == 401) {
                  this.$store.dispatch("Auth/logout").then(() => {
                    this.$router.push("/login");
                  });
                }
              }
              Swal.clickConfirm();
            });
        },
      });
    },
  },
};
</script>
<style lang="scss">
.qr-modal-size {
  max-width: 400px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
